import React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Grid,
    Typography,
} from '@mui/material';
import { CommonModal, PrimaryButton, SecondaryButton } from '../index';
import { trakrefBlue, Grey1, Grey3 } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';

const ExitConfirmationModal = ({
    open,
    close,
    bottom,
    leaveOnClick,
    stayOnClick,
    isEditing,
}) => (
    <CommonModal
        open={open}
        close={close}
        bottom={bottom}
    >
        <Grid container>
            <Grid item xs={12} align='center' sx={{ margin: '6% 0% 1%' }}>
                <Typography
                    variant="h6"
                    sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily } }}
                    style={{ color: Grey1 }}
                    align='center'
                >
                    Are you sure you want to leave this page?
                </Typography>
            </Grid>
            <Grid item xs={12} align='center' sx={{ marginBottom: '8%' }}>
                <Typography
                    variant="paragraph"
                    sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily } }}
                    style={{ color: Grey3 }}
                    align='center'
                >
                    {`${isEditing ? "Any new data" : "Data"} you have entered won't be saved`}
                </Typography>
            </Grid>
            <Grid item xs={12} align='center' mb={2}>
                <PrimaryButton
                    useLargeButton
                    fullWidth
                    buttonText='Leave This Page'
                    onClick={leaveOnClick}
                    width={80}
                />
            </Grid>
            <Grid item xs={12} align='center' mb={3}>
                <SecondaryButton
                    useLargeButton
                    fullWidth
                    buttonText='Stay On This Page'
                    onClick={stayOnClick}
                    width={80}
                />
            </Grid>
        </Grid>
    </CommonModal>
);

ExitConfirmationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    leaveOnClick: PropTypes.func.isRequired,
    stayOnClick: PropTypes.func.isRequired,
    bottom: PropTypes.number,
    isEditing: PropTypes.bool,
};

ExitConfirmationModal.defaultProps = {
    bottom: 20,
    isEditing: false,
};

export default ExitConfirmationModal;
